import { Isp } from './isp';

export class Test {

    public id: number;
    public ping: number;
    public download: number;
    public upload: number;
    public ip: string;
    public ipv6: string;
    public isp: Isp;
    public serverId: number;
    public testType: string;
    public provider: string;
    public version: string;
    public os: string;
    public osVersion: string;
    public deviceInfo: JSON;
    public downloadedData: number;
    public uploadedData: number;
    public downloadHistogram: number[];
    public uploadHistogram: number[];
    public userId: number;
    public testDate: Date;
    public geolocation: any;
    public downloadStability: number;
    public uploadStability: number;

    constructor() {
    }
}
